import "./App.css";

import { useEffect, useState } from "react";

import { Link } from "react-router-dom";
import { WEB_APP_URL } from "./config";

function ForFacilities() {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const [timeLeft, setTimeLeft] = useState({
    days: 0,
    hours: 0,
    minutes: 0,
    seconds: 0,
  });

  const toggleMobileMenu = () => {
    setIsMobileMenuOpen(!isMobileMenuOpen);
  };

  useEffect(() => {
    const calculateTimeLeft = () => {
      const now = new Date().getTime();
      const targetDate = new Date("2026-01-01T00:00:00").getTime();
      const difference = targetDate - now;

      if (difference > 0) {
        const days = Math.floor(difference / (1000 * 60 * 60 * 24));
        const hours = Math.floor(
          (difference % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)
        );
        const minutes = Math.floor(
          (difference % (1000 * 60 * 60)) / (1000 * 60)
        );
        const seconds = Math.floor((difference % (1000 * 60)) / 1000);

        setTimeLeft({ days, hours, minutes, seconds });
      } else {
        setTimeLeft({ days: 0, hours: 0, minutes: 0, seconds: 0 });
      }
    };

    calculateTimeLeft();
    const timer = setInterval(calculateTimeLeft, 1000);

    return () => clearInterval(timer);
  }, []);

  return (
    <div className="bg-black text-gray-200">
      {/* Navbar */}
      <header className="bg-black bg-opacity-70 backdrop-blur-lg sticky top-0 w-full z-50 shadow-lg">
        <nav className="container mx-auto px-6 py-4 flex justify-between items-center">
          <div className="flex items-center space-x-2">
            <img
              src="/images/logo.png"
              alt="Fit-Match Logo"
              className="h-16 w-auto"
            />
            <Link to="/" className="text-2xl font-bold gradient-text">
              FIT-MATCH
            </Link>
          </div>
          <div className="hidden md:flex items-center space-x-8">
            <Link to="/#how-it-works" className="nav-link font-medium">
              How It Works
            </Link>
            <Link to="/our-story" className="nav-link font-medium">
              Our Story
            </Link>
            <Link to="/professionals" className="nav-link font-medium">
              Pros
            </Link>
            <Link to="/training-providers" className="nav-link font-medium">
              Providers
            </Link>
            <Link to="/communities" className="nav-link font-medium">
              Communities
            </Link>
            <Link to="/facilities" className="nav-link font-medium">
              Facilities
            </Link>
            <a
              href={WEB_APP_URL}
              target="_blank"
              rel="noopener noreferrer"
              className="nav-link font-medium px-4 py-2 rounded-lg bg-green-600 hover:bg-green-700 text-white"
            >
              Login
            </a>
          </div>
          <div className="md:hidden">
            <button
              onClick={toggleMobileMenu}
              className="text-white focus:outline-none"
            >
              <svg
                className="w-6 h-6"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="2"
                  d="M4 6h16M4 12h16m-4 6h4"
                ></path>
              </svg>
            </button>
          </div>
        </nav>
        {/* Mobile Menu */}
        <div
          className={`${
            isMobileMenuOpen ? "block" : "hidden"
          } md:hidden bg-black bg-opacity-90 py-4`}
        >
          <Link
            to="/#how-it-works"
            className="block px-6 py-2 text-white font-medium nav-link"
          >
            How It Works
          </Link>
          <Link
            to="/our-story"
            className="block px-6 py-2 text-white font-medium nav-link"
          >
            Our Story
          </Link>
          <Link
            to="/professionals"
            className="block px-6 py-2 text-white font-medium nav-link"
          >
            Pros
          </Link>
          <Link
            to="/training-providers"
            className="block px-6 py-2 text-white font-medium nav-link"
          >
            Providers
          </Link>
          <Link
            to="/communities"
            className="block px-6 py-2 text-white font-medium nav-link"
          >
            Communities
          </Link>
          <Link
            to="/facilities"
            className="block px-6 py-2 text-white font-medium nav-link"
          >
            Facilities
          </Link>
          <a
            href={WEB_APP_URL}
            target="_blank"
            rel="noopener noreferrer"
            className="block px-6 py-2 text-white font-medium nav-link"
          >
            Login
          </a>
        </div>
      </header>

      <main className="pt-24">
        {/* Hero Section */}
        <section className="hero-bg-pro py-12 md:py-20 text-center relative overflow-hidden">
          <div className="absolute inset-0 bg-black bg-opacity-70"></div>
          <div className="container mx-auto px-6 relative z-10">
            <h1 className="text-4xl md:text-6xl font-extrabold leading-tight tracking-tight">
              Showcase Your Facility.{" "}
              <span className="gradient-text">Connect with Clients.</span>
            </h1>
            <p className="mt-4 text-lg md:text-xl max-w-2xl mx-auto">
              The platform designed to help facilities advertise on the map,
              build a network of professionals, and showcase everything you have
              to offer.
            </p>

            {/* Countdown Timer */}
            <div className="mt-8 mb-8">
              <h3 className="text-xl md:text-2xl font-semibold mb-4 text-white">
                Launch Countdown
              </h3>
              <div className="flex justify-center items-center space-x-4 md:space-x-8">
                <div className="bg-gray-800 bg-opacity-80 rounded-lg p-4 md:p-6 text-center min-w-[80px] md:min-w-[100px]">
                  <div className="text-2xl md:text-4xl font-bold text-blue-fit-match">
                    {timeLeft.days}
                  </div>
                  <div className="text-sm md:text-base text-gray-300">Days</div>
                </div>
                <div className="bg-gray-800 bg-opacity-80 rounded-lg p-4 md:p-6 text-center min-w-[80px] md:min-w-[100px]">
                  <div className="text-2xl md:text-4xl font-bold text-blue-fit-match">
                    {timeLeft.hours}
                  </div>
                  <div className="text-sm md:text-base text-gray-300">
                    Hours
                  </div>
                </div>
                <div className="bg-gray-800 bg-opacity-80 rounded-lg p-4 md:p-6 text-center min-w-[80px] md:min-w-[100px]">
                  <div className="text-2xl md:text-4xl font-bold text-blue-fit-match">
                    {timeLeft.minutes}
                  </div>
                  <div className="text-sm md:text-base text-gray-300">
                    Minutes
                  </div>
                </div>
                <div className="bg-gray-800 bg-opacity-80 rounded-lg p-4 md:p-6 text-center min-w-[80px] md:min-w-[100px]">
                  <div className="text-2xl md:text-4xl font-bold text-blue-fit-match">
                    {timeLeft.seconds}
                  </div>
                  <div className="text-sm md:text-base text-gray-300">
                    Seconds
                  </div>
                </div>
              </div>
              <p className="text-sm md:text-base text-gray-300 mt-4">
                Until January 1st, 2026
              </p>
              <div className="mt-4 p-4 bg-blue-fit-match bg-opacity-20 border border-blue-fit-match border-opacity-50 rounded-lg">
                <p className="text-white font-semibold text-sm md:text-base">
                  Early Bird Special: Pre-register before launch and get 6
                  months FREE!
                </p>
              </div>
            </div>

            <div className="mt-8">
              <Link
                to="/preregister-facility"
                className="bg-blue-fit-match text-white font-bold py-3 px-8 rounded-full shadow-lg hover:bg-blue-600 transition duration-300"
              >
                Pre-register as facility now
              </Link>
            </div>
          </div>
        </section>

        {/* Features Section */}
        <section id="features" className="py-20 bg-gray-950">
          <div className="container mx-auto px-6">
            <h2 className="text-3xl md:text-4xl font-bold text-center mb-12">
              Features Designed for Facilities
            </h2>
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
              <div className="bg-gray-800 p-8 rounded-xl shadow-xl transform hover:scale-105 transition duration-300">
                <div className="text-blue-fit-match text-4xl mb-4">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    className="h-12 w-12 mx-auto"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke="currentColor"
                    strokeWidth="1.5"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      d="M9 20l-5.447-2.724A1 1 0 013 16.382V5.618a1 1 0 011.447-.894L9 7m0 13l6-3m-6 3V7m6 10l4.553 2.276A1 1 0 0021 18.382V7.618a1 1 0 00-.553-.894L15 4m0 13V4m0 0L9 7"
                    />
                  </svg>
                </div>
                <h3 className="text-xl font-bold mb-2 text-center">
                  Map Advertising
                </h3>
                <p className="text-gray-400 text-center">
                  Advertise your facility on the interactive map and get
                  discovered by clients actively looking for facilities in your
                  area.
                </p>
              </div>
              <div className="bg-gray-800 p-8 rounded-xl shadow-xl transform hover:scale-105 transition duration-300">
                <div className="text-blue-fit-match text-4xl mb-4">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    className="h-12 w-12 mx-auto"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke="currentColor"
                    strokeWidth="1.5"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      d="M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0zm6 3a2 2 0 11-4 0 2 2 0 014 0zM7 10a2 2 0 11-4 0 2 2 0 014 0z"
                    />
                  </svg>
                </div>
                <h3 className="text-xl font-bold mb-2 text-center">
                  Professional Network
                </h3>
                <p className="text-gray-400 text-center">
                  Accept and showcase professionals under your facility. Build a
                  network of trusted trainers and coaches associated with your
                  brand.
                </p>
              </div>
              <div className="bg-gray-800 p-8 rounded-xl shadow-xl transform hover:scale-105 transition duration-300">
                <div className="text-blue-fit-match text-4xl mb-4">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    className="h-12 w-12 mx-auto"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke="currentColor"
                    strokeWidth="1.5"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      d="M4 16l4.586-4.586a2 2 0 012.828 0L16 16m-2-2l1.586-1.586a2 2 0 012.828 0L20 14m-6-6h.01M6 20h12a2 2 0 002-2V6a2 2 0 00-2-2H6a2 2 0 00-2 2v12a2 2 0 002 2z"
                    />
                  </svg>
                </div>
                <h3 className="text-xl font-bold mb-2 text-center">
                  Rich Profile Gallery
                </h3>
                <p className="text-gray-400 text-center">
                  Showcase your facility with multiple images. Display your
                  space, equipment, and atmosphere to attract clients and
                  professionals.
                </p>
              </div>
              <div className="bg-gray-800 p-8 rounded-xl shadow-xl transform hover:scale-105 transition duration-300">
                <div className="text-blue-fit-match text-4xl mb-4">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    className="h-12 w-12 mx-auto"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke="currentColor"
                    strokeWidth="1.5"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      d="M11.049 2.927c.3-.921 1.603-.921 1.902 0l1.519 4.674a1 1 0 00.95.69h4.915c.969 0 1.371 1.24.588 1.81l-3.976 2.888a1 1 0 00-.363 1.118l1.518 4.674c.3.922-.755 1.688-1.538 1.118l-3.976-2.888a1 1 0 00-1.176 0l-3.976 2.888c-.783.57-1.838-.197-1.538-1.118l1.518-4.674a1 1 0 00-.363-1.118l-3.976-2.888c-.784-.57-.38-1.81.588-1.81h4.914a1 1 0 00.951-.69l1.519-4.674z"
                    />
                  </svg>
                </div>
                <h3 className="text-xl font-bold mb-2 text-center">
                  Reviews & Ratings
                </h3>
                <p className="text-gray-400 text-center">
                  Build credibility with client reviews and ratings. Showcase
                  what makes your facility special and attract new members.
                </p>
              </div>
              <div className="bg-gray-800 p-8 rounded-xl shadow-xl transform hover:scale-105 transition duration-300">
                <div className="text-blue-fit-match text-4xl mb-4">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    className="h-12 w-12 mx-auto"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke="currentColor"
                    strokeWidth="1.5"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      d="M8 7V3m8 4V3m-9 8h.01M3 21h18a2 2 0 002-2V8.656a2 2 0 00-.606-1.424l-3.342-3.342A2 2 0 0013.586 3H10.414A2 2 0 009 5.828v2.172a2 2 0 00-.606 1.424l-3.342 3.342A2 2 0 003 16.344V21z"
                    />
                  </svg>
                </div>
                <h3 className="text-xl font-bold mb-2 text-center">
                  Events Management
                </h3>
                <p className="text-gray-400 text-center">
                  Promote and manage events at your facility. From classes to
                  workshops, keep your community engaged and informed.
                </p>
              </div>
              <div className="bg-gray-800 p-8 rounded-xl shadow-xl transform hover:scale-105 transition duration-300">
                <div className="text-blue-fit-match text-4xl mb-4">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    className="h-12 w-12 mx-auto"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke="currentColor"
                    strokeWidth="1.5"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      d="M13.828 10.172a4 4 0 00-5.656 0l-4 4a4 4 0 105.656 5.656l1.102-1.101m-.758-4.899a4 4 0 005.656 0l4-4a4 4 0 00-5.656-5.656l-1.1 1.1"
                    />
                  </svg>
                </div>
                <h3 className="text-xl font-bold mb-2 text-center">
                  Social Media & Website Links
                </h3>
                <p className="text-gray-400 text-center">
                  Connect your facility's online presence. Link directly to your
                  website and social media profiles to drive traffic and
                  engagement.
                </p>
              </div>
            </div>
          </div>
        </section>

        {/* Screenshots Section */}
        <section id="screenshots" className="py-20 bg-black">
          <div className="container mx-auto px-6 text-center">
            <h2 className="text-3xl md:text-4xl font-bold mb-12">
              Your Facility Profile in Action
            </h2>
            <div className="flex flex-wrap justify-center items-center gap-12">
              <div className="app-screenshot-frame -rotate-3 transform transition duration-300 hover:rotate-0">
                <div
                  className="app-screenshot-inner"
                  style={{
                    backgroundImage:
                      "url('/images/screenshots/facility-map.png')",
                  }}
                ></div>
              </div>
              <div className="app-screenshot-frame rotate-6 transform transition duration-300 hover:rotate-0">
                <div
                  className="app-screenshot-inner"
                  style={{
                    backgroundImage:
                      "url('/images/screenshots/facility-profile.png')",
                  }}
                ></div>
              </div>
              <div className="app-screenshot-frame -rotate-6 transform transition duration-300 hover:rotate-0">
                <div
                  className="app-screenshot-inner"
                  style={{
                    backgroundImage:
                      "url('/images/screenshots/manage-pros.png')",
                  }}
                ></div>
              </div>
            </div>
          </div>
        </section>

        {/* Call to Action Section */}
        <section className="py-20 bg-gray-950">
          <div className="container mx-auto px-6 text-center max-w-4xl">
            <h2 className="text-3xl md:text-4xl font-bold mb-4">
              Ready to Showcase Your Facility?
            </h2>
            <p className="text-lg text-gray-400 leading-relaxed mb-8">
              Join a community of facilities and professionals. Build your
              network, attract clients, and grow your business with Fit-Match.
              It's time to put your facility on the map.
            </p>
            <Link
              to="/preregister-facility"
              className="bg-blue-fit-match text-white font-bold py-3 px-8 rounded-full shadow-lg hover:bg-blue-600 transition duration-300"
            >
              Pre-register as facility now
            </Link>
          </div>
        </section>

        {/* Pricing Section */}
        <section className="py-20 bg-black">
          <div className="container mx-auto px-6">
            <h2 className="text-3xl md:text-4xl font-bold text-center mb-12">
              Facility Membership
            </h2>
            <div className="max-w-2xl mx-auto">
              <div className="bg-gray-800 p-8 rounded-xl shadow-xl transform hover:scale-105 transition duration-300 border border-gray-700">
                <div className="text-center mb-6">
                  <h3 className="text-2xl font-bold mb-2 text-blue-fit-match">
                    Facility Membership
                  </h3>
                  <div className="text-3xl font-bold text-white mb-2">£20</div>
                  <div className="text-gray-400 text-sm">Monthly</div>
                </div>
                <div className="mb-6">
                  <h4 className="text-lg font-semibold mb-3 text-white">
                    What's Included
                  </h4>
                  <ul className="text-gray-400 text-sm leading-relaxed space-y-2">
                    <li className="flex items-start">
                      <span className="text-blue-fit-match mr-2">•</span>
                      <span>
                        Map Advertising - Get discovered by clients searching
                        for facilities in your area
                      </span>
                    </li>
                    <li className="flex items-start">
                      <span className="text-blue-fit-match mr-2">•</span>
                      <span>
                        Professional Network - Accept and showcase professionals
                        under your facility
                      </span>
                    </li>
                    <li className="flex items-start">
                      <span className="text-blue-fit-match mr-2">•</span>
                      <span>
                        Rich Profile - Showcase images, reviews, events, and
                        professional listings
                      </span>
                    </li>
                    <li className="flex items-start">
                      <span className="text-blue-fit-match mr-2">•</span>
                      <span>
                        Social Integration - Link to your website and social
                        media profiles
                      </span>
                    </li>
                    <li className="flex items-start">
                      <span className="text-blue-fit-match mr-2">•</span>
                      <span>
                        Events Management - Promote and manage events at your
                        facility
                      </span>
                    </li>
                    <li className="flex items-start">
                      <span className="text-blue-fit-match mr-2">•</span>
                      <span>
                        Reviews & Ratings - Build credibility with client
                        feedback
                      </span>
                    </li>
                  </ul>
                </div>
                <div className="border-t border-gray-700 pt-4">
                  <h4 className="text-lg font-semibold mb-2 text-white">
                    Pre-Registration Bonus
                  </h4>
                  <p className="text-gray-400 text-sm">
                    Sign up during pre-registration and get 6 months FREE!
                    That's a £120 value. Don't miss out on this exclusive early
                    bird offer.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </section>
      </main>

      {/* Footer */}
      <footer className="bg-gray-900 py-8 text-center text-gray-400">
        <p>&copy; 2024 Fit-Match. All rights reserved.</p>
      </footer>
    </div>
  );
}

export default ForFacilities;
